import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import PageManagerTreeViewItem from './tree-view-item.js';

const LEFT_OFFSET = 34;
const TOP_OFFSET = 20;

/*
  TreeViewItemDragPreview renders the drag preview using createPortal.
  createPortal is necessary to escape any transform: translate3d() on parent elements,
  which would otherwise affect position: fixed positioning and cause the preview
  to appear misaligned from the cursor. By rendering at document.body level,
  the preview positions relative to the viewport (not transformed ancestors),
  ensuring accurate cursor-following behavior.
*/
const TreeViewItemDragPreview = ({ clientOffset = null, item = null, isDragging = false }) => {
  if (!isDragging || !item?.data || !clientOffset) {
    return null;
  }

  const { name, title, password, iconGlyph, isActive } = item.data;

  return createPortal(
    <div
      className="ws-page-manager-tree-view-item-drag-preview"
      style={{
        left: `${clientOffset.x - LEFT_OFFSET}px`,
        top: `${clientOffset.y - TOP_OFFSET}px`,
      }}
    >
      <PageManagerTreeViewItem
        isDragging
        name={name}
        title={title}
        password={password}
        iconGlyph={iconGlyph}
        isActive={isActive}
      />
    </div>,
    document.body
  );
};

TreeViewItemDragPreview.propTypes = {
  clientOffset: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }),
  item: PropTypes.shape({
    data: PropTypes.object,
  }),
  isDragging: PropTypes.bool,
};

export default TreeViewItemDragPreview;
